import '../styles/components/Navbar.scss'
import logo from '../assets/logo.svg'
import { Link, useNavigate } from 'react-router-dom'
import { BiSearch } from "react-icons/bi";
import { FiShoppingCart } from "react-icons/fi";
import { useState } from 'react';
import { HiChevronDown } from "react-icons/hi";
import { IoMenu, IoCloseOutline  } from "react-icons/io5";
import { useCart } from '../contexts/CartContext';
const Navbar = () => {
    const navigate = useNavigate()
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const { getCartItemsCount } = useCart();
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    const closeMenu = () => {
        setIsMenuOpen(false)
    }

    const handleNavigation = (path) => {
        navigate(path)
        closeMenu()
    }

    return(
        <>
            <div className="navbar-container">
                <div className='logo-container' onClick={() => navigate('/')}>
                    <img src={logo} alt='logo Michkette' />
                </div>
                <nav>
                    <Link to='/'> Accueil </Link>
                    <Link to='/AboutUs'> à propos </Link>
                    <div className="nav-item-with-submenu">
                    <div className='products-nav-menu'> Nos articles <HiChevronDown /> </div>
                        <div className="submenu">
                            <Link to='/Products'>Tous les articles</Link>
                            <hr />
                            <Link to='/Products?filter=new'>Nouveautés</Link>
                            <hr />
                            <Link to='/Products?filter=promo'>Articles en promotions</Link>
                        </div>
                    </div>
                    <Link to='/ArticlesPersonnalise'> Articles personnalisés </Link>
                    <Link to='/Contact'> Contact </Link>
                </nav>
                <div className='nav-utils'>
                    <BiSearch />
                    <Link to="/cart" className="cart-link">
                        <FiShoppingCart />
                        {getCartItemsCount() > 0 && (
                        <span className="cart-badge">{getCartItemsCount()}</span>
                        )}
                    </Link>
                </div>
                <div className='mobile-utils'>
                    <BiSearch className='search-mobile' />
                    <button 
                        className={`hamburger-menu ${isMenuOpen ? 'active' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        {!isMenuOpen === true ? <IoMenu size={48} /> : <IoCloseOutline size={48} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            <div className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`}>
                <div className="mobile-nav">
                    <a onClick={() => handleNavigation('/')}>Accueil</a>
                    <a onClick={() => handleNavigation('/Products')}>Nos articles</a>
                    <a onClick={() => handleNavigation('/AboutUs')}>À propos</a>
                    <a onClick={() => handleNavigation('/ArticlesPersonnalise')}>Articles personnalisés</a>
                    <a onClick={() => handleNavigation('/Contact')}>Contact</a>
                    <Link to="/cart" onClick={() => closeMenu()} className="cart-link">
                        <FiShoppingCart /> Panier
                        {getCartItemsCount() > 0 && (
                            <span className="cart-badge">{getCartItemsCount()}</span>
                        )}
                    </Link>
                </div>
            </div>
        </>
    )
}

export default Navbar